module.exports = __webpack_public_path__ + "static/img/hiragana_large_ke-compressor.a4ba44b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/hiragana_large_ke-compressor.gif
// module id = 9k1H
// module chunks = 0